export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8017.a13a914e.jpg";